import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getCampaignType } from 'store/dealManagement/selectors/getCampaignType';
import DealPriority from './DealPriority';
import ExternalReference from './ExternalReference';
import OverrideDealId from './OverrideDealId';
import SelectAdminPerson from './SelectAdminPerson';
import SelectAgency from './SelectAgency';
import { SelectCampaignType } from './SelectCampaignType/SelectCampaignType';
import { SelectDsp } from './SelectDsp/SelectDsp';
import SelectSalesPerson from './SelectSalesPerson';
import SelectSalesTeam from './SelectSalesTeam';
import SelectSpecialist from './SelectSpecialist';
import { InputDealCpm } from './InputDealCpm/InputDealCpm';
import { InputContainer } from './utils';
import { AdvertiserBrandCategoryFields } from './AdvertiserBrandCategoryFields';

const Details = (): React.ReactElement => {
  const { isProgrammaticCampaignType, isDirectSalesCampaignType } = useSelector(getCampaignType);

  const location = useLocation();
  const isDealForm = location.pathname.includes('deal');

  return (
    <div className="flex flex-col" data-test-id="drawer-details">
      {isProgrammaticCampaignType && (
        <InputContainer>
          <SelectCampaignType />
        </InputContainer>
      )}

      <AdvertiserBrandCategoryFields />

      {isDealForm && <SelectDsp />}

      <InputContainer>
        <SelectAgency />
        <SelectSpecialist />
        {isProgrammaticCampaignType && (
          <>
            <ExternalReference />
            <OverrideDealId />
            <DealPriority />
          </>
        )}
        <SelectSalesPerson />
        <SelectSalesTeam />
        {isDirectSalesCampaignType && <SelectAdminPerson />}
      </InputContainer>
      {isProgrammaticCampaignType && isDealForm && (
        <InputContainer>
          <InputDealCpm />
        </InputContainer>
      )}
    </div>
  );
};

export default Details;
